import React, { Component } from 'react';
import { store } from 'Store/store.index';
import { Modal, Spin, message } from 'antd';
import { observer } from 'mobx-react';
import { fileController } from "../viewer/Controllers/index";
import utils from "@foxit/utils";
import folder from '@/assets/docs/folder.png';
import noData from '@/assets/docs/noData.png';
import { COLLABORATION_HEADER } from '@/constants/index'
import './fwDocs.scss';
@observer
class fwDocs extends Component {
  constructor(props) {
    super(props);
    this.getRootFolder = this.getRootFolder.bind(this);
    this.getFindDocList = this.getFindDocList.bind(this);
    this.openFolder = this.openFolder.bind(this);
    this.upload = this.upload.bind(this);
    this.clickUpload = this.clickUpload.bind(this);
    this.openUrlFile = this.openUrlFile.bind(this);
    this.clickFile = this.clickFile.bind(this);
    this.folderId = null;
    this.isFree = true
    this.state = {
      isModalVisible: true,
      isUploadSuccess: true,
      crumbsListArr:[],
      docsListHead:[{
        folderField: "folderName",
        fileField: "fileName",
        name: "文件名",
        sortType: "nameSort",
        sortFall: "nameSortFall",
        sortRise: "nameSortRise",
        defaultSort: "nameSortFall",
        defaultWidth: "60%"
      },
      {
        folderField: "size",
        fileField: "size",
        name: "大小",
        sortType: "sizeSort",
        sortFall: "sizeSortFall",
        sortRise: "sizeSortRise",
        defaultSort: "sizeSortFall",
        defaultWidth: "25%"
      },
      {
        folderField: "createTime",
        fileField: "createTime",
        name: "日期",
        sortType: "dateSort",
        sortFall: "dateSortFall",
        sortRise: "dateSortRise",
        defaultSort: "dateSortFall",
        defaultWidth: "15%"
      }]
    }
  }
  componentDidMount () {
    this.getRootFolder()
  }
  componentWillUnmount() {}
  /**
   * [clickFile 点击文件]
   *
   * @param   {[type]}  docId     [docId 文件id]
   * @param   {[type]}  fileName  [fileName 文件名]
   *
   * @return  {[type]}            [return description]
   */
  clickFile(docId, fileName = ''){
    console.log(store.docsStore.docsModalType)
    if(store.docsStore.docsModalType === "save"){
      this.openUrlFile(docId, fileName);
    } else {
      const token = store.docsStore.docsToken;
      const appKey = store.docsStore.appKey;
      const url = `https://docsapi.foxitcloud.cn/docFile/downloadFile?docId=${docId}&${store.loginNewStore.IAMToken? 'accessToken' : 'token'}=${token}&appKey=${appKey}`;
      store.convert.getConvertUrlFile(url);
      store.convert.getConvertPdfFileName(fileName);
      store.convert.getIsShowFwConvertModal(true);
      this.closeModal();
    }
  }
  /**
   * [openUrlFile 打开云文档文件]
   *
   * @param   {[type]}  docId     [docId 文件id]
   * @param   {[type]}  fileName  [fileName 文件名]
   *
   * @return  {[type]}            [return description]
   */
  openUrlFile(docId, fileName = ''){
    console.log("openUrlFile")
    const token = store.docsStore.docsToken;
    const appKey = store.docsStore.appKey;
    const url = `https://docsapi.foxitcloud.cn/docFile/downloadFile?docId=${docId}&${store.loginNewStore.IAMToken? 'accessToken' : 'token'}=${token}&appKey=${appKey}`;
    // const { onShowToSaveBeforeOpen } = store.appStore;
    // onShowToSaveBeforeOpen((isToSave) => {
      // !isToSave && store.appStore.backToHomeStart();
      fileController.doOpenFileByUrl(url, fileName,(/*err*/) => {}, false, () => {
        this.closeModal();
      });
    // });
    
  }
  clickUpload(){
    document.getElementsByClassName('convertUpload')[0].click();
  }
  /**
   * [filterDocsFileData 过滤列表文件数据]
   *
   * @param   {[type]}  fileData  [fileData 原始列表数据]
   *
   * @return  {[type]}            [return description]
   */
  filterDocsFileData(fileData) {
    const typeArr = ['ppt', 'pptx', 'docx', 'doc', 'xls', 'xlsx', 'jpg', 'png', 'bmp'];
    const filterFileData = fileData.filter(item=>{
      if(store.docsStore.docsModalType === 'convert'){
        if(typeArr.includes(item.extName)){
          return true
        }
      } else {
        if(item.extName === 'pdf'){
          return true
        }
      }
    })
    store.docsStore.getFilterDocsFileData(filterFileData);
  }
  /**
   * [saveToCloud 保存到云文档]
   *
   * @return  {[type]}  [return description]
   */
  saveToCloud = async () => {
    if(!store.docsStore.isSaveSuccess){
      return
    }
    const { headerType } = store.appStore;
    // 处理协同另存云文档
    if(headerType === COLLABORATION_HEADER) {
      try {
        store.docsStore.getIsSaveSuccess(false);
        const fileName = store.addCoverPageStore.fileNameToPDF(store.docStore.docInfo.fileName)
        const uploadRes = await store.docsStore.fileToBlob(fileName, store.docsStore.docsCurrentFolderId, this.isFree);
        if(uploadRes.code === 0){
          store.docsStore.getIsSaveSuccess(true);
          message.success('保存成功');
          store.appStore.doUpdateDocModified(false);
          this.getFindDocList();
        }
      } catch (error) {
        store.docsStore.getIsSaveSuccess(true);
        console.log(error)
      }
      return
    }
    if(store.userNewStore.userData.identity === 'vip'){
      try {
        store.docsStore.getIsSaveSuccess(false);
        const fileName = store.addCoverPageStore.fileNameToPDF(store.docStore.docInfo.fileName)
        const uploadRes = await store.docsStore.fileToBlob(fileName, store.docsStore.docsCurrentFolderId, this.isFree);
        if(uploadRes.code === 0){
          store.docsStore.getIsSaveSuccess(true);
          message.success('保存成功');
          store.appStore.doUpdateDocModified(false);
          this.getFindDocList();
        }
      } catch (error) {
        store.docsStore.getIsSaveSuccess(true);
        console.log(error)
      }
    } else {
      const saveType = 'cloudDocs';
      store.saveFileNewStore.saveFileDialog(saveType);
    }
  }
  /**
   * [closeModal 关闭弹框]
   *
   * @return  {[type]}  [return description]
   */
  closeModal() {
    store.docsStore.getIsSetListSuccess(false);
    store.saveFileNewStore.setIsShowFwDocs(false);
  }
  /**
   * [getRootFolder 获取跟目录id]
   *
   * @return  {[type]}  [return description]
   */
  async getRootFolder() {
    try {
      const getTokenRes = await store.docsStore.getToken();
      if(getTokenRes.code === 0){
        await store.docsStore.getRootFolder()
      }
    } catch (error) {
      console.log(error)
    }
    this.setState({
      crumbsListArr:[{
        folderId: store.docsStore.docsRootFolderId,
        folderName:'云文档'
      }]
    })
    this.getFindDocList();
  }
  /**
   * [openFolder 打开文件夹]
   *
   * @return  {[type]}  [return description]
   */
  openFolder = (folderId, folderName, index) => {
    if(this.state.crumbsListArr.length === index+1){
      return
    }
    store.docsStore.getCurrentFolderId(folderId);
    store.docsStore.getIsSetListSuccess(false);
    this.getFindDocList();
    this.updateCrumbsList(folderId, folderName)
  }
  /**
   * [updateCrumbsList 更新面包屑列表]
   *
   * @param   {[string]}  folderName  [folderName 面包屑名称]
   * @param   {[string]}  folderId    [id 当前目录id]
   *
   * @return  {[type]}        [return description]
   */
  updateCrumbsList(folderId = "", folderName = "") {
    const crumbsListObject = {
      folderId,
      folderName
    };
    const length = this.state.crumbsListArr.length;
    const index = this.state.crumbsListArr.findIndex(item => {
      return item.folderId === folderId;
    });
    if (index === -1) {
      this.state.crumbsListArr.push(crumbsListObject);
    } else {
      this.state.crumbsListArr.splice(index + 1, length - index - 1);
    }
  }
  // 上传
  async upload(e){
    const file = e.target.files[0];
    const fileName = file.name;
    const isFree = true;
    const uploadType = ['ppt', 'pptx', 'docx', 'doc', 'xls', 'xlsx', 'jpg', 'png', 'bmp'];
    const type = fileName.split('.')[fileName.split('.').length-1];
    if(!uploadType.includes(type)){
      message.success('仅支持转换 Word、Excel、PPT和图片格式');
      return
    }
    this.setState({
      isUploadSuccess:false
    })
    try {
      await store.docsStore.uploadDocument(file, fileName, store.docsStore.docsCurrentFolderId, isFree);
      message.success('上传成功');
      this.setState({
        isUploadSuccess:true
      })
    } catch (error) {
      
    }
    this.getFindDocList();
  }
  /**
   * [getFindDocList 获取list数据]
   *
   * @return  {[type]}  [return description]
   */
  async getFindDocList() {
    try {
      const getFindDocFolderRes = await store.docsStore.getFindDocFolder(store.docsStore.docsCurrentFolderId)
      if(getFindDocFolderRes.code === 0){
        store.docsStore.getDocsFolderData(getFindDocFolderRes.data?getFindDocFolderRes.data:[])
        try {
          let getFindDocFileRes = await store.docsStore.getFindDocFile(store.docsStore.docsCurrentFolderId, 1, 10000)
          if(getFindDocFileRes.code === 0){
            store.docsStore.getDocsFileData(getFindDocFileRes.data.records?getFindDocFileRes.data.records:[])
            store.docsStore.getIsSetListSuccess(true);
            this.filterDocsFileData(store.docsStore.docsFileData);
          }
        } catch (error) {
          console.log(error)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  
  render() {
    const {
      isModalVisible,
      docsListHead,
      crumbsListArr,
      isUploadSuccess
    } = this.state;
    const { isSaveSuccess, isSetListSuccess, docsFolderData, docsModalType, filterDocsFileData } = store.docsStore;
    const listContent = <div className='listContent'>
                  <input className='convertUpload' type='file' accept=".ppt, .pptx, .docx, .doc, .xls, .xlsx, .jpg, .png, .bmp" onChange={this.upload}/>
                  {docsModalType === "convert" && <button className='clickConvert' onClick={this.clickUpload}>上传</button>}
                  <div className="crumbs">
                    <ul>
                      { crumbsListArr.length > 1 &&
                          crumbsListArr.map((item, index)=>{
                            return (
                              <li key={index} onClick={this.openFolder.bind(this, item.folderId, item.folderName, index)}>
                                <span>{item.folderName}</span>
                                {crumbsListArr.length !== index+1 && <i className="arrowRight">&gt;</i>}
                              </li>
                            ) 
                          })
                      }
                    </ul>
                  </div>
                  <div className="list">
                    <div className="listHead">
                        { !!docsListHead && docsListHead.length !== 0 &&
                          docsListHead.map((item, index)=>{
                            return (
                              <div className="listItem" key={index} style={{"width":item.defaultWidth}}>
                                <div className="listItemI" >
                                  <span>{item.name}</span>
                                </div>
                              </div>
                            ) 
                          })
                        }
                    </div>
                    { isSetListSuccess && <div className="listMain">
                      { docsFolderData.length !== 0 &&
                        docsFolderData.map((item, index)=>{
                          return (
                            <div className="listItem" key={index}>
                              { docsListHead.length !== 0 &&
                                docsListHead.map((items, indexI)=>{
                                  return (
                                    <div className="listItemI" key={indexI} style={{"width":items.defaultWidth}} onClick={this.openFolder.bind(this, item.folderId, item.folderName)}>
                                      {items.folderField === 'folderName' && <img className="icon" src={folder} />}
                                      {
                                        items.fileField === 'createTime'
                                        ?<span>{item[items.folderField].split(' ')[0]}</span>
                                        :<span>{item[items.folderField]}</span>
                                      }
                                    </div>
                                  ) 
                                })
                              }
                            </div>
                          ) 
                        })
                      }
                      { filterDocsFileData.length !== 0 &&
                        filterDocsFileData.map((item, index)=>{
                            return (
                              <div className="listItem" key={index}>
                                { docsListHead.length !== 0 &&
                                  docsListHead.map((items, indexI)=>{
                                      return (
                                        <div className="listItemI" key={indexI} onClick={this.clickFile.bind(this, item.docId, item.fileName)} style={{"width":items.defaultWidth}}>
                                          {/* { items.fileField === 'fileName' && <img className="icon" src={`@/assets/docs/${item.extName}.png`} /> } */}
                                          { 
                                            items.fileField === 'fileName'
                                            ?item.extName === 'pdf'
                                            ?<img className="icon" src={require('@/assets/docs/pdf.png')}/>
                                            :item.extName === 'xls' || item.extName === 'xlsx'
                                            ?<img className="icon" src={require('@/assets/docs/excel.png')}/>
                                            :item.extName === 'jpg'|| item.extName === 'bmp' || item.extName === 'jpeg' || item.extName === 'png'                                
                                            ?<img className="icon" src={require('@/assets/docs/jpg.png')}/>
                                            :item.extName === 'ppt'|| item.extName === 'pptx'
                                            ?<img className="icon" src={require('@/assets/docs/ppt.png')}/>
                                            :item.extName === 'docx'|| item.extName === 'doc'
                                            ?<img className="icon" src={require('@/assets/docs/word.png')}/>
                                            :<img className="icon" src={require('@/assets/docs/other.png')}/>
                                            :''
                                          }
                                          { items.fileField === 'size'
                                            ?<span>{utils.util.formatFileSize(item[items.fileField])}</span>
                                            :items.fileField === 'createTime'
                                            ?<span>{item[items.fileField].split(' ')[0]}</span>
                                            :<span>{item[items.fileField]}</span>
                                          }
                                        </div>
                                      ) 
                                  })
                                }
                              </div>
                            )
                        })
                      }
                      {
                        docsFolderData.length === 0 
                        && filterDocsFileData.length === 0 
                        && <div className="listNoData">
                            <div className="listNoDataW">
                              <img src={noData}/> 
                              <span>暂无文档</span>
                            </div>
                          </div>
                      }
                    </div> }
                    { !isSetListSuccess && <div className='docsLoading'><Spin></Spin></div> }
                    { !isUploadSuccess && <div className='uploadLoading'><Spin></Spin></div> }
                  </div>
              </div>;
    return (
      <React.Fragment>
        {docsModalType === "convert"?<Modal 
          title={docsModalType === "save"?"保存云文档":"云文档"} 
          visible={isModalVisible} 
          className="docsModal"
          okText="保存"
          cancelText=""
          onOk={this.saveToCloud}
          onCancel={this.closeModal}
          confirmLoading={!isSaveSuccess}
          footer={null} 
          width="1000px"
          height="610px">
            {listContent}
        </Modal>:<Modal 
          title={docsModalType === "save"?"保存云文档":"云文档"} 
          visible={isModalVisible} 
          className="docsModal"
          okText="保存"
          cancelText=""
          onOk={this.saveToCloud}
          onCancel={this.closeModal}
          confirmLoading={!isSaveSuccess}
          width="1000px"
          height="610px">
            {listContent}
        </Modal>}
        
      </React.Fragment>
    );
  }
}
export default fwDocs
